import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import Library1 from "../Images/Library/Library1.png";
import Library3 from "../Images/Library/libary3.jpg";
import libary4 from "../Images/Library/libary4.jpg";
import libary5 from "../Images/Library/libary5.jpg";
import libary6 from "../Images/Library/libary6.jpg";
import libary7 from "../Images/Library/libary7.jpg";
import libary8 from "../Images/Library/libary8.jpg";
import libary9 from "../Images/Library/libary9.jpg";
import libary10 from "../Images/Library/libary10.jpg";

const Library = () => {
  return (
    <>
      <section className="p-5 mx-md-5">
        <h1>Library of Bar Association Dehradun</h1>
        <Row className="mt-1 g-3">
          <Col md={6} sm={11}>
            <img
              src={Library1}
              className="img-fluid w-100 h-100"
              alt="img..."
            />
          </Col>
          <Col md={6} sm={11}>
            <img
              src={Library3}
              className="img-fluid w-100 h-100"
              alt="img..."
            />
          </Col>
        </Row>
        <Row className="mt-1 g-3">
          <Col md={6} sm={11}>
            <img src={libary4} className="img-fluid w-100 h-100" alt="img..." />
          </Col>
          <Col md={6} sm={11}>
            <img src={libary5} className="img-fluid w-100 h-100" alt="img..." />
          </Col>
        </Row>
        <Row className="mt-1 g-3">
          <Col md={6} sm={11}>
            <img src={libary6} className="img-fluid w-100 h-100" alt="img..." />
          </Col>
          <Col md={6} sm={11}>
            <img src={libary7} className="img-fluid w-100 h-100" alt="img..." />
          </Col>
        </Row>
        <Row className="mt-1 g-3">
          <Col md={6} sm={11}>
            <img src={libary8} className="img-fluid w-100 h-100" alt="img..." />
          </Col>
          <Col md={6} sm={11}>
            <img src={libary9} className="img-fluid w-100 h-100" alt="img..." />
          </Col>
        </Row>
        <Row className="mt-1 g-3">
          <Col md={6} sm={11}>
            <img
              src={libary10}
              className="img-fluid w-100 h-100"
              alt="img..."
            />
          </Col>
        </Row>
      </section>
    </>
  );
};

export default Library;
